import React from "react";

export const ExtractCurrencyFormatter = (values) => {
    return values?.currencyIn?.name
}

export const ExtractOutCurrencyFormatter = (values) => {
    return values?.currencyOut?.name
}